/* eslint-disable @typescript-eslint/no-explicit-any  */
/* eslint-disable @typescript-eslint/no-non-null-assertion  */
import { Box, Button, Colors, FlexBox, H1, Text } from '@helloself/hello-self-ui';
import { Fragment, useRef, useState } from 'react';
import IdleTimer from 'react-idle-timer';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { RootState } from '../../../app/store';
import { logoutAndClearCaches } from '../../auth/slice';

export interface SessionTimeoutProps {
    logoutTime?: number;
    warningTime?: number;
}

export const SessionTimeout = (props: SessionTimeoutProps) => {
    const [showTimer, setShowTimer] = useState(false);

    const idleTimerRef = useRef<IdleTimer | null>(null);
    const sessionTimeoutRef = useRef<null | ReturnType<typeof setTimeout>>(null);

    const logoutTime = props.logoutTime ? props.logoutTime : SessionTimeout.defaultProps.logoutTime;
    const warningTime = props.warningTime ? props.warningTime : SessionTimeout.defaultProps.warningTime;

    const isAuthenticated = useAppSelector((state: RootState) => state.authentication.isAuthenticated);
    const dispatch = useAppDispatch();

    const isLocal = window.REACT_APP_NODE_ENV === 'local' || window.REACT_APP_NODE_ENV === 'development';

    if (isLocal) {
        return null;
    }

    const logoutUser = async () => {
        dispatch(logoutAndClearCaches());
        setShowTimer(false);
    };

    const onIdleHandler = () => {
        setShowTimer(true);
        sessionTimeoutRef.current = setTimeout(logoutUser, warningTime);
    };

    const stayActive = () => {
        setShowTimer(false);
        clearTimeout(sessionTimeoutRef.current!);
    };

    return (
        <Fragment>
            {isAuthenticated && <IdleTimer ref={idleTimerRef as any} timeout={logoutTime} onIdle={onIdleHandler} />}
            {showTimer && isAuthenticated && (
                <Container>
                    <Box
                        width="100%"
                        maxWidth="400px"
                        padding="40px 30px"
                        backgroundColor={Colors.white}
                        borderRadius="10px"
                    >
                        <H1>Are you there?</H1>
                        <Text margin="30px 0" textSize="large">
                            To help keep your account secure and our members' details private we'll sign you out
                            after&nbsp;
                            {logoutTime / 60 / 1000} minutes of inactivity.
                        </Text>
                        <FlexBox flexDirection="column" alignItems="center" className="buttons">
                            <Button width="200px" onClick={stayActive} margin="0 0 10px" display="member-primary">
                                I'm still here
                            </Button>
                            <Button width="200px" onClick={logoutUser} display="member-secondary">
                                Log me out now
                            </Button>
                        </FlexBox>
                    </Box>
                </Container>
            )}
        </Fragment>
    );
};
SessionTimeout.defaultProps = {
    warningTime: 1000 * 60 * 4, // four minutes
    logoutTime: 1000 * 60 * 5, // five minutes
};

const Container = styled.div`
    position: fixed;
    z-index: 2000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;
